import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {GARoleTypeId} from '../../util/uiconstants';
export function groupTaskFilterReducer(state = initialstate.groupTaskFilter, action) {
	switch (action.type) {
		case actions.UPDATE_GROUP_TASKS_FILTERS: {
			if (action.payload && action.payload.gaRoleTypeId == GARoleTypeId.Component) {
				if (!action.payload.filterType) {
					return {
						...state,
						componentEngagementtaskFilters: action.payload.taskFilters,
						componentEngagementDocumentFilters: action.payload.documentFilters
					};
				}
				if (action.payload.filterType == 1) {
					return {
						...state,
						componentEngagementtaskFilters: action.payload.taskFilters
					};
				} else if (action.payload.filterType == 2) {
					return {
						...state,
						componentEngagementDocumentFilters: action.payload.documentFilters
					};
				}
			} else {
				if (action.payload) {
					if (action.payload.filterType == 1) {
						return {
							...state,
							primaryEngagementtaskFilters: action.payload.taskFilters
						};
					}
					if (action.payload.filterType == 2) {
						return {
							...state,
							primaryEngagementdocumentFilters: action.payload.documentFilters
						};
					}
					if (!action.payload.filterType) {
						return {
							...state,
							primaryEngagementtaskFilters: action.payload.taskFilters,
							primaryEngagementdocumentFilters: action.payload.documentFilters
						};
					}
				}
			}
			return {
				...state
			};
		}
		case actions.GET_GROUP_AUDIT_COMPONENTS:
			return initialstate.groupTaskFilter;

		default:
			return state;
	}
}
